<template>
  <div>
    <p class="flex flex-center" style="fontSize:17px;margin: 10px;" v-if="show">
      据开始还有{{ time }}
    </p>
    <p class="flex flex-center" style="fontSize:17px;margin: 10px;" v-else>
      活动已开始
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: "",
      flag: false,
      show: true
    };
  },
  mounted() {
    let time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(time);
      }
      this.timeDown();
    }, 500);
  },
  props: {
    endTime: {
      type: String
    }
  },
  methods: {
    timeDown() {
      const endTime = new Date(this.endTime);
      const nowTime = new Date();
      let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
      if (leftTime > 0) {
        this.show = true;
        let d = parseInt(leftTime / (24 * 60 * 60));
        let h = this.formate(parseInt((leftTime / (60 * 60)) % 24));
        let m = this.formate(parseInt((leftTime / 60) % 60));
        let s = this.formate(parseInt(leftTime % 60));
        if (leftTime <= 0) {
          this.flag = true;
          this.$emit("time-end");
        }
        this.time = `${d}天${h}小时${m}分${s}秒`; // 需要修改时间样式的话 ，比如需要什么30分钟倒计时，就只保留分和秒
      } else {
        this.show = false;
      }
    },
    formate(time) {
      if (time >= 10) {
        return time;
      } else {
        return `0${time}`;
      }
    }
  }
};
</script>

<style scoped></style>
